module.exports = __webpack_public_path__ + "img/background_15.698e1b59.jpg";